"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const glamor_1 = require("glamor");
const glamor_tachyons_1 = require("glamor-tachyons");
class SurfaceComponent extends preact_1.Component {
    componentDidMount() {
        const { name, tab } = this.props;
        this.props.registerSurface(name, tab, this);
    }
    componentDidUpdate() {
        return false;
    }
    render() {
        const { name, visible, styles } = this.props;
        const finalStyles = Object.assign({}, SurfaceComponent.defaultStyles, styles);
        const { width, height, } = finalStyles;
        let { maxHeight, maxWidth, } = finalStyles;
        maxHeight = height === SurfaceComponent.defaultStyles.height ?
            maxHeight : height;
        maxWidth = width === SurfaceComponent.defaultStyles.width ?
            maxWidth : width;
        const surfaceStyle = glamor_1.css({
            display: visible ? 'block' : 'none',
            backgroundColor: 'white',
            marginTop: '10px',
            marginBottom: '10px',
            boxShadow: '0 0 6px -3px #777',
            padding: '10px !important',
            height,
            width,
            maxHeight,
            maxWidth,
            overflow: 'auto',
        });
        const labelStyle = glamor_1.css(Object.assign({ backgroundColor: 'white', boxSizing: 'border-box', borderBottom: '1px solid #357EDD', lineHeight: '2em', marginBottom: '20px' }, glamor_tachyons_1.tachyons('fw6 tc')));
        const drawAreaStyle = glamor_1.css({
            boxSizing: 'border-box',
        });
        return (preact_1.h("div", { className: `${surfaceStyle} tf-surface`, ref: (r) => this.container = r, "data-visible": visible },
            preact_1.h("div", { className: `${labelStyle} tf-label`, ref: (r) => this.label = r }, name),
            preact_1.h("div", { className: `${drawAreaStyle} tf-draw-area`, ref: (r) => this.drawArea = r })));
    }
}
SurfaceComponent.defaultStyles = {
    maxWidth: '580px',
    maxHeight: '580px',
    height: 'auto',
    width: 'auto',
};
exports.SurfaceComponent = SurfaceComponent;
//# sourceMappingURL=surface.js.map